(function () {
    'use strict';

    angular
        .module('iMatApp')
        .factory('productIssueFactory', productIssueFactory);

    productIssueFactory.$inject = ['eventService', 'utils', 'muIssueMessagesData'];

    function productIssueFactory(eventService, utils, muIssueMessagesData) {
        return {
            createGeneralError: createGeneralError,
            createInvalidFileType: createInvalidFileType,
            createInvalidFileSize: createInvalidFileSize,
            createFileNameTooLong: createFileNameTooLong,
            createUploadFileError: createUploadFileError,
            createNotAcceptedV3ResultsWarning: createNotAcceptedV3ResultsWarning,
            createAlreadyHasV3ResultsWarning: createAlreadyHasV3ResultsWarning,
            createInvalidModelError: createInvalidModelError,
            createModelIsAborted: createModelIsAborted,
            createProcessingFailedError: createProcessingFailedError,

            createDimensionsUnderLimit: createDimensionsUnderLimit,
            createDimensionsAboveLimit: createDimensionsAboveLimit,
            createDimensionsBelowLimit: createDimensionsBelowLimit,
            createPriceLimit: createPriceLimit,
            createNoOnlinePrice: createNoOnlinePrice,
            createPriceError: createPriceError
        };

        // -------------------------------------------------------------------------------------

        function createGeneralError(product) {
            var messageKey = 'general-error';
            var action = createRemoveModelAction(product);

            return createTranslatableErrorIssue('generalError', messageKey, null, [action]);
        }

        function createInvalidFileType(product) {
            var messageKey = 'multiple-upload_issue-message-invalid-file-type';
            var action = createRemoveModelAction(product);

            var messageData = {
                allowedFileTypes: muIssueMessagesData.allowedFileExtensions,
                supportedFileTypesPageUrl: muIssueMessagesData.supportedFileTypesPageUrl
            };

            return createTranslatableErrorIssue('invalidFileType', messageKey, messageData, [action]);
        }

        function createInvalidFileSize(product) {
            var messageKey = 'multiple-upload_issue-message-invalid-file-size';
            var action = createRemoveModelAction(product);

            var messageData = {
                maxFileSizeMb: utils.round(muIssueMessagesData.maxFileSizeMb, 1)
            };

            return createTranslatableErrorIssue('invalidFileSize', messageKey, messageData, [action]);
        }

        function createFileNameTooLong(product) {
            var messageKey = 'multiple-upload_issue-message-file-name-too-long';
            var action = createRemoveModelAction(product);

            var messageData = {
                maxFileNameLength: muIssueMessagesData.maxFileNameLength
            };

            return createTranslatableErrorIssue('fileNameTooLong', messageKey, messageData, [action]);
        }

        function createUploadFileError(product) {
            var messageKey = 'multiple-upload_issue-message-upload-file-general-error';
            var action = createRemoveModelAction(product);

            return createTranslatableErrorIssue('uploadFileGeneralError', messageKey, null, [action]);
        }

        function createNotAcceptedV3ResultsWarning(product) {
            var messageKey = 'multiple-upload_issue-message-not-accepted-v3-results';
            var actions = [createAcceptRepairAction(product), createDeclineRepairAction(product)];

            return createTranslatableQuestionIssue('NotAcceptedV3Results', messageKey, null, actions);
        }

        function createAlreadyHasV3ResultsWarning(product) {
            var messageKey = 'multiple-upload_issue-message-already-has-v3-results';
            var action = createRefreshAction(product);

            return createTranslatableWarningIssue('AlreadyHasV3Results', messageKey, null, [action]);
        }        

        function createInvalidModelError(product) {
            var messageKey = 'multiple-upload_issue-message-invalid-model';

            return createTranslatableErrorIssue('InvalidModel', messageKey, null, null);
        }

        function createModelIsAborted(product) {
            var messageKey = 'multiple-upload_issue-message-aborted-model';
            var action = createRemoveModelAction(product);

            return createTranslatableErrorIssue('abortedModel', messageKey, null, [action]);
        }

        function createProcessingFailedError(product) {
            var messageKey = 'multiple-upload_issue-message-processing-model-failed';

            var messageData = {
                helpCenterUrl: muIssueMessagesData.helpCenterUrl
            };

            return createTranslatableErrorIssue('ProcessingFailed', messageKey, messageData, null);
        }

        // ------------------------------------------- Pricing errors ----------------------------------------------

        function createDimensionsUnderLimit(product, reason) {
            var action = createScaleToFitAction(product, reason.scaleToFit);

            return createWarningIssue('DimensionsUnderLimit', reason.message, [action]);
        }

        function createDimensionsAboveLimit(product, reason) {
            var action = createScaleToFitAction(product, reason.scaleToFit);

            return createWarningIssue('DimensionsAboveLimit', reason.message, [action]);
        }

        function createDimensionsBelowLimit(product, reason) {
            var action = createScaleToFitAction(product, reason.scaleToFit);

            return createWarningIssue('DimensionsBelowLimit', reason.message, [action]);
        }

        function createNoOnlinePrice(product) {
            var messageKey = 'multiple-upload_issue-message-pricing-no-online-price';

            return createTranslatableWarningIssue('NoOnlinePrice', messageKey, null, null);
        }

        function createPriceLimit(product) {
            var messageKey = 'multiple-upload_issue-message-pricing-price-limit';

            return createTranslatableWarningIssue('PriceLimit', messageKey, null, null);
        }

        function createPriceError(product) {
            return createProcessingFailedError(product);
        }

        // ----------------------------------------------- Actions -------------------------------------------------

        function createRemoveModelAction(product) {
            var func = function () {
                eventService.notify('CancelProductProcessing', product);
            };

            return createAction('CancelProductProcessing', 'multiple-upload_issue-action-remove', func);
        }

        function createScaleToFitAction(product, scaleToFit) {
            var func = function () {
                product.scale(scaleToFit);
            }

            return createAction('ScaleToFit', 'multiple-upload_issue-action-scale-to-fit', func);
        }

        function createAcceptRepairAction(product) {
            var func = function () {
                eventService.notify('AcceptRepair', product);
            }

            return createAction('AcceptRepair', 'multiple-upload_issue-action-accept-repair', func);
        }

        function createDeclineRepairAction(product) {
            var func = function () {
                eventService.notify('DeclineRepair', product);
            }

            return createAction('DeclineRepair', 'multiple-upload_issue-action-undo-repair', func);
        }

        function createRefreshAction(product) {
            var func = function () {
                eventService.notify('RefreshProduct', product);
            }

            return createAction('RefreshProduct', 'multiple-upload_issue-action-refresh-product', func);
        }        

        function createAction(code, titleKey, func) {
            return {
                code: code,
                titleKey: titleKey,
                func: func
            }
        }

        // ---------------------------------------------------------------------------------------------------------

        function createErrorIssue(type, message, actions) {
            return createIssue('error', type, message, null, null, actions);
        }

        function createWarningIssue(type, message, actions) {
            return createIssue('warning', type, message, null, null, actions);
        }

        function createTranslatableErrorIssue(type, messageKey, messageData, actions) {
            return createIssue('error', type, null, messageKey, messageData, actions);
        }

        function createTranslatableWarningIssue(type, messageKey, messageData, actions) {
            return createIssue('warning', type, null, messageKey, messageData, actions);
        }

        function createTranslatableQuestionIssue(type, messageKey, messageData, actions) {
            return createIssue('question', type, null, messageKey, messageData, actions);
        }

        function createIssue(severity, type, message, messageKey, messageData, actions) {
            var issue = {
                severity: severity,
                type: type,
                message: message,
                messageKey: messageKey,
                messageData: messageData,
                actions: actions,

                isError: function () { return this.severity === 'error' },
                isWarning: function () { return this.severity === 'warning' },
                isQuestion: function () { return this.severity === 'question' },

                isOpr: function () {
                    return this.type === 'PriceLimit' ||
                        this.type === 'NoOnlinePrice' ||
                        this.type === 'ProcessingFailed' ||
                        this.type === 'InvalidModel';
                },

                get priority() {
                    if (this.isError() || this.isWarning()) {
                        return 1;
                    }

                    return 2;
                }
            };

            return issue;
        }
    }
}());